import React from "react";
import ScrollableAnchor from "react-scrollable-anchor";

class PossibilitiesSection extends React.Component {

  ourValues = [
    {
      title: "Reha Sport",
      icon: "icon-move",
      anchor: "reha"
    },
    {
      title: "Funktionstraining",
      icon: "icon-gym",
      anchor: "training"
    },
    {
      title: "Entspannungskurse",
      icon: "icon-relax",
      anchor: "relax"
    },
    {
      title: "Personaltraining",
      icon: "icon-partner",
      anchor: "personal"
    },
    {
      title: "Seminare",
      icon: "icon-yoga",
      anchor: ""
    },
    {
      title: "Ernährungsberatung (Biofeedback)",
      icon: "icon-healthy",
      anchor: "healthy"
    },
    {
      title: "Massagen",
      icon: "icon-massage",
      anchor: "massage"
    },
    {
      title: "Persönliche Beratung",
      icon: "icon-trainer",
      anchor: "personal"
    }
  ];

  jumpto = (event) => {
    window.location = "/kursinfo#" + event.target.id;
  };

  render = () => {
    return <ScrollableAnchor id="possibilities">
      <section className="possibilities content-section bg-dark text-white text-center">
        <div className="container">
          <div className="content-section-heading">
            <h3 className="text-secondary mb-0">Möglichkeiten</h3>
            <h2 className="mb-5">Unser Angebot</h2>
          </div>
          <div className="row animatedParent animateOnce" data-sequence='500' data-appear-top-offset='-300'>
            {this.ourValues.map((service, index) => (
                <div className="col-lg-3 col-md-6 mb-5 animated bounceIn" key={`service_${index}`} data-id={index + 1}
                     onClick={this.jumpto}>
                  <div className="possi-icon rounded-circle mx-auto mb-3 center padding-top mouseover">
                    <i className={service.icon} id={service.anchor}/>
                  </div>
                  <h4>
                    <strong>{service.title}</strong>
                  </h4>
                </div>
            ))}
          </div>
        </div>
      </section>
    </ScrollableAnchor>
  };
}
export default PossibilitiesSection;



// WEBPACK FOOTER //
// ./src/main/possibilities.js